/**
 * Business-error model for the Licences index.
 *
 * A read-only list only ever loads, so its failures are exactly the generic
 * infra failures (`network` | `api`); no `validation` / `cancelled` variant
 * (unlike the list wizards). The shared classification lives in
 * `@/utils/infra-error`; this module only pins the feature-specific default
 * message. Local to the feature so it never couples to another domain.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type LicencesError = InfraFailure;

/** Map an infrastructure error into a domain `LicencesError`. */
export function toLicencesError(e: unknown): LicencesError {
  return classifyInfraError(e, 'Failed to load licences.');
}
